<template>
  <main>
    <div class="container help-page-wrap">
    	<div class="row">
        <div class="col-12 offset-md-2 col-md-8 offset-lg-2 col-lg-8 no-pad-both">

    			<ul id="help-ul">
    				<li class="white-box">
    					<h1>Cookies og persondata</h1>
    		      <span class="blue-text" @click="changeCookieSettings">Skift dine indstillinger for cookies</span><br>
    		      <router-link :to="{path: '/privatlivspolitik'}" class="blue-text">Læs om Cookie- og privatlivspolitik på Odense Rundt</router-link><br>
    				</li>
    				<li class="white-box">
    					<h1>Få hjælp og tips til Odense Rundt</h1>
    		      <p>Få hjælp til, hvordan du kan bruge Odense Rundt, ved at slå hjælpeteksterne til.</p>
    				</li>

    				<li class="white-box">
              Hjælpetekst til startsiden:
    					<span id="OdenseRundt-TutorialIntroSr" class="sr-only"></span>
  						<div class="btn-group float-right">
  							<button type="button" id="OdenseRundt-TutorialIntroFalse" class="btn" aria-label="Slå fra" @click="toggleTutorial($event, 'OdenseRundt-TutorialIntro', false, 'intro-tutorial');">Fra</button>
    						<button type="button" id="OdenseRundt-TutorialIntroTrue" class="btn" aria-label="Slå til" @click="toggleTutorial($event, 'OdenseRundt-TutorialIntro', true, 'intro-tutorial');">Til</button>
  						</div>
    				</li>

    				<li class="white-box">
              Hjælpetekst til Ruteplanlæggeren:
    					<span id="OdenseRundt-TutorialDirectionsSr" class="sr-only"></span>
  						<div class="btn-group float-right">
  							<button type="button" id="OdenseRundt-TutorialDirectionsFalse" class="btn" aria-label="Slå fra" @click="toggleTutorial($event, 'OdenseRundt-TutorialDirections', false, 'directions-tutorial');">Fra</button>
    						<button type="button" id="OdenseRundt-TutorialDirectionsTrue" class="btn" aria-label="Slå til" @click="toggleTutorial($event, 'OdenseRundt-TutorialDirections', true, 'directions-tutorial');">Til</button>
  						</div>
    				</li>

    				<li class="white-box">
              Hjælpetekst til et tema:
    					<span id="OdenseRundt-TutorialTagSr" class="sr-only"></span>
  						<div class="btn-group float-right">
  							<button type="button" id="OdenseRundt-TutorialTagFalse" class="btn" aria-label="Slå fra" @click="toggleTutorial($event, 'OdenseRundt-TutorialTag', false, 'tag-tutorial');">Fra</button>
    						<button type="button" id="OdenseRundt-TutorialTagTrue" class="btn" aria-label="Slå til" @click="toggleTutorial($event, 'OdenseRundt-TutorialTag', true, 'tag-tutorial');">Til</button>
  						</div>
    				</li>

    				<li class="white-box">
              Hjælpetekst til et sted:
    					<span id="OdenseRundt-TutorialPlaceSr" class="sr-only"></span>
  						<div class="btn-group float-right">
  							<button type="button" id="OdenseRundt-TutorialPlaceFalse" class="btn" aria-label="Slå fra" @click="toggleTutorial($event, 'OdenseRundt-TutorialPlace', false, 'place-tutorial');">Fra</button>
    						<button type="button" id="OdenseRundt-TutorialPlaceTrue" class="btn" aria-label="Slå til" @click="toggleTutorial($event, 'OdenseRundt-TutorialPlace', true, 'place-tutorial');">Til</button>
  						</div>
    				</li>

    				<li class="white-box">
      				<router-link class="blue-text" to="/about">Læs mere om formålet med Odense Rundt, og hvem der står bag.</router-link>
    				</li>
    				<li class="white-box">
      				<router-link :to="{path: '/iframeguide/rute'}" class="blue-text">Få vist vej til dig på din hjemmeside – integrer kort fra Odense Rundt. Se vejledning her</router-link><br>
    				</li>
    				<li class="white-box">
      				<router-link :to="{path: '/iframeguide/oversigt'}" class="blue-text">Få vist overblik over et tema på din hjemmeside – integrer kort fra Odense Rundt. Se vejledning her</router-link>
    				</li>
    			</ul>
        </div>
    	</div>
    </div>
    <Footer></Footer>
  </main>
</template>

<script>
import Footer from '@/components/Footer.vue'
import { EventBus } from '@/main.js'

export default {
  data() {
    return {
    }
  },
  components: {
    Footer,
  },
  created() {
    this.$HelperFunctions.scrollToTop();
    this.$HelperFunctions.setPageTitle('Hjælp');
  },
  mounted() {
    this.$HelperFunctions.setScreenReaderFocus();
    this.checkTutorialValues();
  },
  methods: {
    changeCookieSettings() {
      EventBus.$emit('changeCookieSettings');
    },

  	checkTutorialValues() {
  		var tutorials = ['OdenseRundt-TutorialIntro','OdenseRundt-TutorialDirections','OdenseRundt-TutorialTag','OdenseRundt-TutorialPlace'];
  		for(var i = 0; i < tutorials.length; i++) {
  			var showTutorial = localStorage.getItem(tutorials[i]);
  			if(showTutorial == 'true') {
  				document.getElementById(tutorials[i]+'True').classList.add('blue');
  				document.getElementById(tutorials[i]+'Sr').innerHTML = 'Status: Slået til';
  			}
  			else {
  				document.getElementById(tutorials[i]+'False').classList.add('blue');
  				document.getElementById(tutorials[i]+'Sr').innerHTML = 'Status: Slået fra';
  			}
  		}
  	},

  	toggleTutorial(element, tutorialId, tutorialValue, tutorialName) {
      if(localStorage.getItem('OdenseRundt-FunctionalCookies') == 'true') {
  			var allBtns = element.currentTarget.parentNode.querySelectorAll('button');

        for(var i = 0; i < allBtns.length; i++) {
          allBtns[i].classList.remove('blue');
        }
  			element.currentTarget.classList.add('blue');

        document.getElementById(tutorialId+'Sr').innerHTML = (tutorialValue == 'true') ? 'Status: Slået til' : 'Status: Slået fra';

  			this.$HelperFunctions.trackSession('tutorial-reactivated', tutorialName);

        localStorage.setItem(tutorialId, tutorialValue);
      }
      else {
        var obj = {message: 'For at få vist hjælpetekster, skal du acceptere brugen af funktionelle cookies.', btnText: 'Ok', callbackType: 'function', callback: this.changeCookieSettings};
        EventBus.$emit('openMessageBox', obj);
      }
  	}
  },
}
</script>

<style lang="scss" scoped>
  .help-page-wrap {
    padding-top: 10px;
    padding-bottom: 10px;
  }

	h1 {
		font-size: 1.5rem;
	}

  #help-ul {
  	margin-bottom: 0;
    padding: 0px 5px 0px 5px;
  }

  #help-ul li {
  	margin-top: 10px;
  	border-bottom: 1px solid #dedede;
  	font-size: 13px;
  	padding: 10px 10px;
  	line-height: 30px;
  }

  #help-ul li:first-child {
    margin-top: 0px;
  }

  .btn {
    font-size: 13px;
    border: 1px solid #eee;
  }
</style>
